/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem, Box } from "@mui/material";

// import for excel download
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

import { assetImages } from "constants";

import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AddLabelModal from "components/Common/Modal/AddLabelModal";

import LogFilterPopup from "../Popup/LogFilterPopup";
import SaveLogPopup from "../Popup/SaveLogPopup";
import LogListHeader from "../Header/LogListHeader";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import LogListFilterPopup from "components/Common/Popup/LogListFilterPopup";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

const AllLogListBody = () => {
  const params = useParams();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation
  // -------- breadcrumb text --------
  const breadCrumbText = [{ title: t("Logs") }];

  const [isLoading, setIsLoading] = useState(false);
  const [logList, setLogList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  const [totalLogHours, settotalLogHours] = useState(0);
  const [totalLogCosts, settotalLogCosts] = useState(0);

  const [selectedLogIds, setSelectedLogIds] = useState([]);
  const [selectedLogId, setSelectedLogId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});

  const [filterStartDate, setfilterStartDate] = useState("");
  const [filterEndDate, setfilterEndDate] = useState("");
  const [filterTags, setFilterTags] = useState([]);
  const [filterUserIds, setfilterUserIds] = useState([]);
  const [filterProjectIds, setfilterProjectIds] = useState([]);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  const [isNoDefaultFilter, setIsNoDefaultFilter] = useState(false);

  // Pagination -------------------------------------------
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // download to excel
  const [excelData, setExcelData] = useState([]);

  //get task logs
  const getTaskLogs = async () => {
    setRowSelection({});
    setSelectedLogIds([]);

    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_PROJECT_TASK_LOGS;

      if (filterStartDate != "") {
        requestUrl = requestUrl + `&filterstartdate=${filterStartDate}`;
      }

      if (filterEndDate != "") {
        requestUrl = requestUrl + `&filterenddate=${filterEndDate}`;
      }

      if (filterTags.length > 0) {
        requestUrl = requestUrl + `&filtertags=${filterTags}`;
      }

      if (filterUserIds.length > 0) {
        requestUrl = requestUrl + `&filterlogusers=${filterUserIds}`;
      }

      if (filterProjectIds.length > 0) {
        requestUrl = requestUrl + `&filterlogprojects=${filterProjectIds}`;
      }

      console.log("request url", requestUrl);

      const response = await getData(requestUrl);

      console.log("response", response);

      if (response.status) {
        setMessageType("success");
        setLogList(response.data);

        const totalHours = response.data.reduce(
          (acc, curr) => acc + curr.hours,
          0
        );

        settotalLogHours(totalHours);

        const totalPrice = response.data.reduce(
          (acc, curr) => acc + curr.price,
          0
        );

        settotalLogCosts(totalPrice);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    } finally {
      setIsLoading(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  // get filtered logs
  const getFilteredLogs = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_FILTERED_PROJECT_TASK_LOGS +
        ``;

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      // reset pagination to default
      if (response.status) {
        setMessageType("success");
        setLogList(response.data);

        // get total hours and price
        const totalHours = response.data.reduce(
          (acc, curr) => acc + curr.hours,
          0
        );

        settotalLogHours(totalHours); // set total hours

        // get total price
        const totalPrice = response.data.reduce(
          (acc, curr) => acc + curr.price,
          0
        );

        settotalLogCosts(totalPrice); // set total price
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsLoading(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  //function for change status API_DELETE_BULK_LOGS
  const changeStatusHandler = async () => {
    if (selectedLogIds.length > 0) {
      const itemToBeDelete = logList.filter((item) =>
        selectedLogIds.includes(item._id)
      );

      try {
        let apiData = {
          loglist: itemToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_LOGS;

        const response = await putData(requestURL, apiData);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setLogList((prevLogs) =>
              prevLogs.filter((item) => !selectedLogIds.includes(item._id))
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }

      setShowAlert(true);
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one item");
      setShowAlert(true);
    }
  };

  //function for remove tag from log
  const removeTagFromLog = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_TAG_TASK_LOG;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedLogId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setLogList((prevLogs) => replaceListByIds(prevLogs, data));
    }, 1000);
  };

  //function for reset filter
  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
    // reset pagination to default
    setLastPagination({
      pageIndex: 0,
      pageSize: 10,
    });
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });
  };

  //material table columns array
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <button
          className="action_btn_mui"
          data-bs-toggle="offcanvas"
          data-bs-target="#saveLog"
          aria-controls="saveLog"
          onClick={() => {
            setSelectedLogId(row.original._id);
          }}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </button>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "customid",
      header: t("Id"),
      size: 100,
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      size: 200,
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist.map((tag, index) => (
                  <li key={index} className="d-inline-flex">
                    <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                      <span className="badge-text fs-xs fw-medium me-1">
                        {tag.title}
                      </span>
                      <Link
                        to="#"
                        className={`${
                          tag.moderator.toString() ===
                            userInfo._id.toString() ||
                          userInfo.role.slug === "ADMIN" ||
                          userInfo.role.slug === "SUPER_ADMIN"
                            ? "d-block"
                            : "d-none"
                        }`}
                        onClick={() => {
                          setSelectedLogId(row.original._id);
                          setSelectedTagId(tag._id);
                          removeTagFromLog([tag._id], row.original._id);
                        }}
                      >
                        {selectedTagId &&
                        selectedTagId === tag._id &&
                        selectedLogId &&
                        selectedLogId === row.original._id ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary ms-1"
                            role="status"
                            style={{ height: "12px", width: "12px" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        ) : (
                          <span
                            className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                            style={{ cursor: "pointer" }}
                          >
                            cancel
                          </span>
                        )}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedLogIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    // {
    //   accessorKey: "taskcustomid",
    //   header: t("Task Id"),
    //   size: 100,

    //   Cell: ({ row }) => (
    //     <Box className="title border-bottom-0">
    //       <div className="d-flex align-items-center gap-4">
    //         <Link
    //           to={`/admin/task/details/${row.original.projecttaskid}`}
    //           className="d-flex align-items-center gap-1 fs-md"
    //         >
    //           {row.original.taskcustomid}
    //         </Link>
    //       </div>
    //     </Box>
    //   ),
    // },
    {
      accessorKey: "tasktitle",
      header: t("Task"),
      size: 250,
      Cell: ({ row }) => (
        <Box className="title border-bottom-0">
          <div className="d-flex align-items-center gap-4">
            <Link
              to={`/admin/task/details/${row.original.projecttaskid}`}
              className="d-flex align-items-center gap-1 fs-md"
            >
              {row.original.taskcustomid} : {row.original.tasktitle}
            </Link>
          </div>
        </Box>
      ),
    },
    {
      accessorKey: "projectname",
      header: t("Project"),
      size: 300,
      Cell: ({ row }) =>
        row.original.project ? (
          <Box className="title border-bottom-0">
            <div className="d-flex align-items-center gap-4">
              <Link
                to={`/admin/projectmanagement/details/${row.original.project._id}`}
                className="d-flex align-items-center gap-1 fs-md"
              >
                {row.original.projectname}
              </Link>
            </div>
          </Box>
        ) : null,
    },
    {
      accessorKey: "leadtitle",
      header: t("Lead"),
      Cell: ({ row }) => (
        <Box className="title border-bottom-0">
          <div className="d-flex align-items-center gap-4">
            <Link
              to={
                row.original.leadid
                  ? `/admin/crm/lead/information/${row.original.leadid}`
                  : "#"
              }
              className="d-flex align-items-center gap-1 fs-md"
            >
              {row.original.leadtitle}
            </Link>
          </div>
        </Box>
      ),
    },
    {
      accessorKey: "contactname",
      header: t("Contact"),
      Cell: ({ row }) => (
        <Box className="title border-bottom-0">
          <div className="d-flex align-items-center gap-4">
            <Link
              to={
                row.original.contactid
                  ? `/admin/crm/contact/details/timeline/${row.original.contactid}`
                  : "#"
              }
              className="d-flex align-items-center gap-1 fs-md"
            >
              {row.original.contactname}
            </Link>
          </div>
        </Box>
      ),
    },
    {
      accessorKey: "username",
      header: t("Log Added By"),
      size: 300,
      Cell: ({ row }) => (
        <div className="owner border-bottom-0 d-flex gap-1">
          {row.original.assignedusername === "" ? null : (
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.userimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.userimage
              }
              alt="Babcock"
            />
          )}
          <p>
            <span className="d-block">{row.original.username}</span>
            <span className="d-block">{row.original.useremail}</span>
          </p>
          <button
            onClick={() => {
              createContactChatHandler(
                row.original.logownerid,
                "MOD_LOG",
                row.original._id,
                row.original.tasktitle.slice(0, 20)
              );
            }}
            className={
              !row.original.logownerid ||
              row.original.logownerid === userInfo._id
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
    },
    {
      accessorKey: "logstartdate",
      header: t("From Date"),
    },
    {
      accessorKey: "logenddate",
      header: t("To Date"),
    },
    {
      accessorKey: "hours",
      header: t("Hours"),
    },
    {
      accessorKey: "logcreateddate",
      header: t("Log Created Date"),
    },
  ];

  /*
   * Material React Table Column and States
   */
  const columns = useMemo(
    () => initialTableColumns,
    [selectedTagId, logList, i18n.language]
  );

  /* Updates the column visibility state by toggling the visibility of the column with the given accessor key.*/
  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  /* Represents the state of column visibility in the table.*/
  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState
  );

  /* Updates the column visibility state based on the new column state.*/
  const onColumnVisiblityHandler = (newColumnState) => {
    const newColumnStateName = newColumnState();
    setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
  };

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //function for change column order
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getFilteredLogs();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getTaskLogs();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedLogIds(selectedIdsArray);
    } else {
      setSelectedLogIds([]);
    }
  }, [rowSelection]);

  // save the last pagination
  useEffect(() => {
    setLastPagination({
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  //refresh icon function
  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  //download as excel
  const downloadAsExcel = () => {
    if (logList.length > 0) {
      const createRowData = (apiData) => [
        apiData.projectname,
        apiData.sectionname,
        apiData.leadtitle,
        apiData.contactname,
        apiData.taskcustomid,
        apiData.tasktitle,
        apiData.projectmoderator,
        apiData.username,
        apiData.startdate,
        apiData.hours,
        apiData.price,
        apiData.taskpercent,
        apiData.taskstatus,
        apiData.tagstring,
        apiData.description.length > 32000
          ? "Too large to display"
          : apiData.description,
      ];

      const filteredLogList =
        selectedLogIds.length > 0
          ? logList.filter((logItem) => selectedLogIds.includes(logItem._id))
          : logList;

      filteredLogList.map((apiData) => {
        const rowData = createRowData(apiData);
        setExcelData((prevState) => [...prevState, rowData]);
      });
    }
  };

  const createExcel = () => {
    const fileName = "logs";
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const Heading = [
      [
        "Project",
        "Section",
        "Lead",
        "Contact",
        "Task Id",
        "Task Title",
        "Owner",
        "Provider",
        "Date",
        "Hours",
        "Price",
        "% Complete",
        "Status",
        "Label",
        "Task Description",
      ],
    ];
    const ws = XLSX.utils.json_to_sheet(excelData, {
      origin: "A2",
      skipHeader: true,
    });
    XLSX.utils.sheet_add_aoa(ws, Heading, { origin: "A1" });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const filedata = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(filedata, fileName + fileExtension);
  };

  useEffect(() => {
    if (excelData.length > 0) {
      createExcel();
      setExcelData([]);
    }
  }, [excelData]);

  // download excel ends

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_LOGS")
  ) {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            {/* ------- bread crumb -------- */}

            {/* ------- filter area --------- */}
            <LogListHeader
              breadCrumbText={breadCrumbText}
              reloadList={refreshRecords}
              downloadAsExcel={downloadAsExcel}
              logList={logList}
              totalLogHours={totalLogHours}
              totalLogCosts={totalLogCosts}
              selectedLogIds={selectedLogIds}
              jsonFilterQuery={jsonFilterQuery}
            />

            {!isDataReady || isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={logList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  enableColumnOrdering={true}
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }} //pass our managed row selection state to the table to use
                  onPaginationChange={setPagination} // set pagination
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ========= popups and modals area ========= */}
        {/* --------- Add label modal ---------- */}
        <AddLabelModal
          moduleName="tasklog"
          selectedIds={selectedLogIds}
          afterTagModalClose={afterModalActionClose}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          setShowAlert={setShowAlert}
          onModalClose={() => {
            setSelectedLogIds([]);
            setRowSelection({});
          }}
        />

        <SaveLogPopup
          selectedLogId={selectedLogId}
          onPopUpClose={() => {
            setSelectedLogId(null);
          }}
          afterLogSave={afterModalActionClose}
        />

        {/* ---------- filter popup --------- */}

        <LogListFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          moduleSlug="allloglist"
          reloadList={refreshRecords}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          visibleColoumns={visibleColoumns}
          setVisibleColoumns={setVisibleColoumns}
          columnOrder={columnOrder}
          setColumnOrder={setColumnOrder}
          columns={columns}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedLogIds([]);
          }}
          onDelete={changeStatusHandler}
          moduleName={t("log")}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default AllLogListBody;
